function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";

/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var generatePaymentsByMonthPerCreditColumns = function generatePaymentsByMonthPerCreditColumns(data) {
  var months = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!data || data.length === 0) return [];
  var fixedColumns = [{
    name: 'Дата на отпускане',
    value: 'credit_start_date',
    width: '120px'
  }, {
    name: 'Договор №',
    value: 'number',
    width: '130px'
  }, {
    name: 'Период',
    render: function render(_ref) {
      var period_months = _ref.period_months;
      return ___EmotionJSX("span", null, period_months, " \u043C\u0435\u0441.");
    },
    width: '80px'
  }, {
    name: 'Главница',
    render: function render(_ref2) {
      var principal = _ref2.principal,
          currency = _ref2.currency;
      return ___EmotionJSX("span", null, principal, " ", currency);
    },
    width: '100px'
  }, {
    name: 'Лихва',
    render: function render(_ref3) {
      var interest = _ref3.interest,
          currency = _ref3.currency;
      return ___EmotionJSX("span", null, interest, " ", currency);
    },
    width: '100px'
  }];
  var monthColumns = (months || []).flatMap(function (month) {
    return [{
      name: "".concat((month === null || month === void 0 ? void 0 : month.monthName) || '', ": \u0433\u043B\u0430\u0432\u043D\u0438\u0446\u0430"),
      render: function render(row) {
        var _row$payments_by_mont, _row$payments_by_mont2;

        var value = ((_row$payments_by_mont = row.payments_by_month) === null || _row$payments_by_mont === void 0 ? void 0 : (_row$payments_by_mont2 = _row$payments_by_mont[month === null || month === void 0 ? void 0 : month.monthKey]) === null || _row$payments_by_mont2 === void 0 ? void 0 : _row$payments_by_mont2.principal) || '';
        return value > 0 ? "".concat(value, " ").concat(row.currency) : '';
      },
      width: '110px',
      invisibleBelow: 3000,
      hideIfEmpty: true
    }, {
      name: "".concat((month === null || month === void 0 ? void 0 : month.monthName) || '', ": \u043B\u0438\u0445\u0432\u0430"),
      render: function render(row) {
        var _row$payments_by_mont3, _row$payments_by_mont4;

        var value = ((_row$payments_by_mont3 = row.payments_by_month) === null || _row$payments_by_mont3 === void 0 ? void 0 : (_row$payments_by_mont4 = _row$payments_by_mont3[month === null || month === void 0 ? void 0 : month.monthKey]) === null || _row$payments_by_mont4 === void 0 ? void 0 : _row$payments_by_mont4.interest) || '';
        return value > 0 ? "".concat(value, " ").concat(row.currency) : '';
      },
      width: '110px',
      invisibleBelow: 3000,
      hideIfEmpty: true
    }, {
      name: "".concat((month === null || month === void 0 ? void 0 : month.monthName) || '', ": \u043D\u0430\u043A. \u043B\u0438\u0445\u0432\u0430"),
      render: function render(row) {
        var _row$payments_by_mont5, _row$payments_by_mont6;

        var value = ((_row$payments_by_mont5 = row.payments_by_month) === null || _row$payments_by_mont5 === void 0 ? void 0 : (_row$payments_by_mont6 = _row$payments_by_mont5[month === null || month === void 0 ? void 0 : month.monthKey]) === null || _row$payments_by_mont6 === void 0 ? void 0 : _row$payments_by_mont6.penalty) || '';
        return value > 0 ? "".concat(value, " ").concat(row.currency) : '';
      },
      width: '110px',
      invisibleBelow: 3000,
      hideIfEmpty: true
    }];
  });
  var restColumns = [{
    name: 'Дължим остатък - Главница',
    render: function render(_ref4) {
      var rest_principal = _ref4.rest_principal,
          currency = _ref4.currency;
      return ___EmotionJSX("span", null, rest_principal, " ", currency);
    },
    width: '140px'
  }, {
    name: 'Дължим остатък - Лихва',
    render: function render(_ref5) {
      var rest_interest = _ref5.rest_interest,
          currency = _ref5.currency;
      return ___EmotionJSX("span", null, rest_interest, " ", currency);
    },
    width: '140px'
  }];
  return [].concat(fixedColumns, _toConsumableArray(monthColumns), restColumns);
};